import { renderModel } from '../util/renderModel';

const getParentUrlReferral = (url: string | null): string | null => {
  return url ? new URL(url)?.searchParams.get('referral') : null;
};

const url = new URL(window.location.href);
const isFullWidth = renderModel.isFullWidth();

export const parentUrl = url.searchParams.get('loadPageUrl');
export const referralUrl = url.searchParams.get('referral_url') || document.referrer;

export const locale = renderModel.getLocale();
export const referral = isFullWidth ? getParentUrlReferral(parentUrl) : url.searchParams.get('referral');

export const getChatbotSendButtonId = (isAiEnabled: boolean) =>
  isAiEnabled ? 'send_button_V2' : 'send_button_V1';
